import React, { useMemo } from 'react';
import { Sliders, RotateCcw } from 'lucide-react';
import Accordion from '../common/Accordion';

// Varsayılan değerler - Uygulama genelinde tutarlı olması için burada tanımlıyoruz
const DEFAULT_PARAMS = {
  electricityPrice: 4, // TL/kWh - Demoya eşit
  gasPrice: 12,         // TL/sm3 - Demoya eşit
  co2Factor: 2.34          // kg/kWh
};

const ParameterControl = ({ 
  darkMode, 
  activeAccordion, 
  setActiveAccordion, 
  globalParams, 
  handleGlobalParamChange 
}) => {
  
  // Değerlerin varsayılan değerlerden farklı olup olmadığını kontrol et
  const isDefaultDirty = useMemo(() => {
    return Object.keys(DEFAULT_PARAMS).some(key => 
      Math.abs(DEFAULT_PARAMS[key] - globalParams[key]) > 0.001
    );
  }, [globalParams]);
  
  // Tüm parametreleri varsayılan değerlerine sıfırlama fonksiyonu
  const resetToDefaults = () => {
    Object.keys(DEFAULT_PARAMS).forEach(key => {
      handleGlobalParamChange(key, DEFAULT_PARAMS[key]);
    });
  };
  
  return (
    <Accordion
      isActive={activeAccordion === 'parameters'}
      title="Parametreler"
      icon={Sliders}
      iconColor="blue"
      bgColor="blue"
      darkMode={darkMode}
      onToggle={() => setActiveAccordion(activeAccordion === 'parameters' ? null : 'parameters')}
    >
      <div className="p-3 space-y-4">
        {/* Elektrik Fiyatı */}
        <div>
          <label className={`block text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-2`}>
            <span>Elektrik Fiyatı (TL/kWh)</span>
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="range"
              className="flex-grow"
              min="1"
              max="10"
              step="0.1"
              value={globalParams.electricityPrice}
              onChange={(e) => handleGlobalParamChange('electricityPrice', parseFloat(e.target.value))}
            />
            <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'} w-16`}>
              {parseFloat(globalParams.electricityPrice).toFixed(0)}
            </span>
          </div>
        </div>

        {/* Doğalgaz Fiyatı */}
        <div>
          <label className={`block text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-2`}>
            Doğalgaz Fiyatı (TL/sm3)
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="range"
              className="flex-grow"
              min="1"
              max="50"
              step="0.1"
              value={globalParams.gasPrice}
              onChange={(e) => handleGlobalParamChange('gasPrice', parseFloat(e.target.value))}
            />
            <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'} w-16`}>
              {parseFloat(globalParams.gasPrice).toFixed(1)}
            </span>
          </div>
        </div>
        
        {/* CO2 Faktörü 
        <div>
          <label className={`block text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-2`}>
            CO₂ Faktörü (kg/kWh)
          </label>
          <div className="flex items-center space-x-2">
            <input
              type="range"
              className="flex-grow"
              min="0.5"
              max="3.0"
              step="0.1"
              value={globalParams.co2Factor}
              onChange={(e) => handleGlobalParamChange('co2Factor', parseFloat(e.target.value))}
            />
            <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'} w-16`}>
              {parseFloat(globalParams.co2Factor).toFixed(2)}
            </span>
          </div>
        </div> */}
        
        {/* Varsayılan Değerlere Döndür Butonu - En altta */}
        {isDefaultDirty && (
          <div className="flex justify-center mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
            <button
              onClick={resetToDefaults}
              className={`flex items-center justify-center px-3 py-1.5 rounded-md text-sm font-medium ${
                darkMode 
                ? 'bg-blue-700 hover:bg-blue-600 text-white' 
                : 'bg-blue-100 hover:bg-blue-200 text-blue-700'
              } transition-colors w-full`}
            >
              <RotateCcw size={16} className="mr-2" />
              Varsayılan Değerlere Döndür
            </button>
          </div>
        )}
      </div>
    </Accordion>
  );
};

export default ParameterControl;